(function () {
  'use strict';

  var QUIZ_DATA = {
    questions: [
      {
        id: 1,
        text: "What is your biological sex?",
        type: "single",
        category: "Calorie Tracking",
        options: ["Male", "Female"]
      },
      {
        id: 2,
        text: "How old are you?",
        type: "single",
        category: "Calorie Tracking",
        options: ["18-25", "26-35", "36-45", "46-55", "55+"]
      },
      {
        id: 3,
        text: "What is your current height and weight?",
        type: "height_weight",
        category: "Calorie Tracking"
      },
      {
        id: 4,
        text: "Do you experience any of the following?",
        subtext: "Select all that apply",
        type: "multi",
        category: "Calorie Tracking",
        options: [
          "High blood pressure",
          "High cholesterol",
          "PCOS",
          "Sleep apnea",
          "Thyroid issue",
          "Joint pain / low energy",
          "Strong craving / difficulty filling full",
          "Pre-diabetic / type 2 diabetes",
          "None of the above"
        ]
      },
      {
        id: 5,
        text: "What weight would make you feel like yourself again?",
        subtext: "Enter your goal weight",
        type: "goal_weight",
        category: "Calorie Tracking"
      },
      {
        id: 6,
        text: "Why are you trying to lose weight?",
        subtext: "Pick the one that fits best",
        type: "single",
        category: "Calorie Tracking",
        options: [
          "To have more energy day by day",
          "To get in shape and feel confident",
          "For an upcoming event ( wedding, holiday)",
          "To recover from an injury",
          "Because of medical condition",
          "To feel like myself again"
        ]
      }
    ]
  };

  var QUALIFYING_CONDITIONS = [
    'High blood pressure', 'High cholesterol', 'PCOS',
    'Sleep apnea', 'Thyroid issue', 'Pre-diabetic / type 2 diabetes'
  ];

  var state = { current: 0, answers: {}, unit: 'metric' };

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }

  function checkSVG() {
    return '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7L5.5 10.5L12 3.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function dotSVG() {
    return '<svg width="8" height="8" viewBox="0 0 8 8"><circle cx="4" cy="4" r="4" fill="#2d8b72"/></svg>';
  }

  // ─── Overlay ────────────────────────────────────────────────────────────────

  function buildOverlay() {
    var overlay = el('div', 'hq-overlay');
    overlay.id = 'hq-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'HealthifyRx Quiz');
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeQuiz();
    });

    var card = el('div', 'hq-card');
    card.id = 'hq-card';

    var header = el('div', 'hq-header');
    var logoHtml = (window.hqLogoUrl)
      ? '<div class="hq-logo"><img src="' + window.hqLogoUrl + '" alt="' + (window.hqLogoAlt || 'Logo') + '" class="hq-logo-img"></div>'
      : '<div class="hq-logo"><div class="hq-logo-icon">H</div><span>Healthify<strong>Rx</strong></span></div>';
    header.innerHTML = logoHtml;
    var closeBtn = el('button', 'hq-close');
    closeBtn.setAttribute('aria-label', 'Close quiz');
    closeBtn.innerHTML = '&#10005;';
    closeBtn.addEventListener('click', closeQuiz);
    header.appendChild(closeBtn);

    var progressWrap = el('div', 'hq-progress-bar-wrap');
    progressWrap.id = 'hq-progress-wrap';
    var body = el('div', 'hq-body');
    body.id = 'hq-body';
    var footer = el('div', 'hq-footer');
    footer.id = 'hq-footer';

    body.appendChild(footer);   // footer lives inside the white body card

    card.appendChild(header);
    card.appendChild(progressWrap);
    card.appendChild(body);
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    return overlay;
  }

  // ─── Progress ───────────────────────────────────────────────────────────────

  function renderProgress(qIndex, total) {
    var wrap = document.getElementById('hq-progress-wrap');
    if (!wrap) return;
    wrap.style.display = '';

    // Build segments once; update classes in-place on subsequent calls
    var segsContainer = wrap.querySelector('.hq-progress-segments');
    if (!segsContainer) {
      var html = '<div class="hq-progress-meta"><span class="hq-prog-step"></span><span class="hq-prog-pct"></span></div>' +
        '<div class="hq-progress-track"><div class="hq-progress-segments">';
      for (var i = 0; i < total; i++) html += '<div class="hq-progress-seg"></div>';
      html += '</div></div>';
      wrap.innerHTML = html;
      segsContainer = wrap.querySelector('.hq-progress-segments');
    }

    var pct = Math.round(((qIndex + 1) / total) * 100);
    wrap.querySelector('.hq-prog-step').textContent = 'Question ' + (qIndex + 1) + ' of ' + total;
    wrap.querySelector('.hq-prog-pct').textContent  = pct + '% Complete';

    // Update filled state — CSS transition animates the change smoothly
    var segEls = segsContainer.querySelectorAll('.hq-progress-seg');
    segEls.forEach(function (seg, i) {
      if (i <= qIndex) seg.classList.add('hq-done');
      else seg.classList.remove('hq-done');
    });
  }

  function hideProgress() {
    var wrap = document.getElementById('hq-progress-wrap');
    if (wrap) wrap.style.display = 'none';
  }

  // ─── Question renderer ──────────────────────────────────────────────────────

  function renderQuestion(index) {
    var q = QUIZ_DATA.questions[index];
    var body = document.getElementById('hq-body');
    var footer = document.getElementById('hq-footer');

    var oldCtaWrap = document.querySelector('.hq-cta-sticky-wrap');
    if (oldCtaWrap) oldCtaWrap.parentNode.removeChild(oldCtaWrap);

    body.style.padding = '';
    footer.className = 'hq-footer';
    body.innerHTML = '';
    footer.innerHTML = '';

    var qHeader = el('div', 'hq-question-header');
    qHeader.innerHTML =
      '<span class="hq-q-label">Question ' + (index + 1) + '</span>' +
      '<span class="hq-category-tag">' + q.category + '</span>';
    body.appendChild(qHeader);
    body.appendChild(el('p', 'hq-q-text', q.text));
    if (q.subtext) body.appendChild(el('p', 'hq-q-sub', q.subtext));

    if (q.type === 'single' || q.type === 'multi') {
      renderOptions(q, index, body);
    } else if (q.type === 'height_weight') {
      renderHeightWeight(index, body);
    } else if (q.type === 'goal_weight') {
      renderGoalWeight(index, body);
    }

    var errMsg = el('div', 'hq-validation-error');
    errMsg.id = 'hq-val-err';
    body.appendChild(errMsg);

    renderFooter(index, footer);
    body.appendChild(footer);   // re-attach after innerHTML clear
    renderProgress(index, QUIZ_DATA.questions.length);
    scrollTop();
  }

  // ─── Option rendering ───────────────────────────────────────────────────────

  function renderOptions(q, index, body) {
    var saved = state.answers[index] || (q.type === 'multi' ? [] : null);
    var colClass = q.options.length <= 2 ? '' : (q.options.length >= 7 ? ' hq-three-col' : '');
    var optionsDiv = el('div', 'hq-options' + colClass);

    q.options.forEach(function (opt, i) {
      var letter = String.fromCharCode(65 + i);
      var isSelected = q.type === 'multi'
        ? (Array.isArray(saved) && saved.indexOf(opt) > -1)
        : saved === opt;

      var optEl = el('div', 'hq-option' + (isSelected ? ' hq-selected' : ''));
      optEl.innerHTML =
        '<div class="hq-option-badge">' + letter + '</div>' +
        '<span class="hq-option-text">' + opt + '</span>';

      optEl.addEventListener('click', function () {
        if (q.type === 'single') {
          optionsDiv.querySelectorAll('.hq-option').forEach(function (o) {
            o.classList.remove('hq-selected');
          });
          optEl.classList.add('hq-selected');
          state.answers[index] = opt;
          setTimeout(function () { goNext(index); }, 280);
        } else {
          var cur = Array.isArray(state.answers[index]) ? state.answers[index].slice() : [];
          if (opt === 'None of the above') {
            var wasNone = optEl.classList.contains('hq-selected');
            optionsDiv.querySelectorAll('.hq-option').forEach(function (o) {
              o.classList.remove('hq-selected');
            });
            if (!wasNone) {
              optEl.classList.add('hq-selected');
              cur = ['None of the above'];
            } else {
              cur = [];
            }
          } else {
            var noneIdx = cur.indexOf('None of the above');
            if (noneIdx > -1) {
              cur.splice(noneIdx, 1);
              var noneEl = optionsDiv.querySelector('.hq-option:last-child');
              if (noneEl) noneEl.classList.remove('hq-selected');
            }
            var idx = cur.indexOf(opt);
            if (idx > -1) { cur.splice(idx, 1); optEl.classList.remove('hq-selected'); }
            else { cur.push(opt); optEl.classList.add('hq-selected'); }
          }
          state.answers[index] = cur;
        }
      });

      optionsDiv.appendChild(optEl);
    });

    body.appendChild(optionsDiv);
  }

  // ─── Height / Weight ────────────────────────────────────────────────────────

  function saveHWValues(index) {
    var ans = state.answers[index] || {};
    ans.unit = state.unit;
    if (state.unit === 'metric') {
      var hcm = document.getElementById('hq-height-cm');
      var wkg = document.getElementById('hq-weight-kg');
      if (hcm) ans.heightCm = parseFloat(hcm.value) || 0;
      if (wkg) ans.weightKg = parseFloat(wkg.value) || 0;
      ans.heightM = (ans.heightCm || 0) / 100;
    } else {
      var hft = document.getElementById('hq-height-ft');
      var hin = document.getElementById('hq-height-in');
      var wkg2 = document.getElementById('hq-weight-kg');
      if (hft) ans.heightFt = parseFloat(hft.value) || 0;
      if (hin) ans.heightIn = parseFloat(hin.value) || 0;
      if (wkg2) ans.weightKg = parseFloat(wkg2.value) || 0;
      ans.heightM = ((ans.heightFt || 0) * 30.48 + (ans.heightIn || 0) * 2.54) / 100;
    }
    state.answers[index] = ans;
  }

  function renderHeightWeight(index, body) {
    var unit = state.unit;
    var saved = state.answers[index] || {};

    var toggleRow = el('div');
    toggleRow.style.cssText = 'display:flex;justify-content:flex-end;margin-bottom:16px;';
    var toggle = el('div', 'hq-unit-toggle');
    ['Metric', 'Imperial'].forEach(function (u) {
      var uLower = u.toLowerCase();
      var btn = el('button', 'hq-unit-btn' + (unit === uLower ? ' hq-unit-active' : ''), u);
      btn.addEventListener('click', function () {
        if (state.unit === uLower) return;
        saveHWValues(index);
        state.unit = uLower;
        renderQuestion(index);
      });
      toggle.appendChild(btn);
    });
    toggleRow.appendChild(toggle);
    body.appendChild(toggleRow);

    var fieldsDiv;
    if (unit === 'metric') {
      fieldsDiv = el('div', 'hq-hw-fields');
      fieldsDiv.appendChild(buildField('Height (cm)', 'hq-height-cm', 'number', saved.heightCm || '', '170'));
      fieldsDiv.appendChild(buildField('Weight (kg)', 'hq-weight-kg', 'number', saved.weightKg || '', '80'));
    } else {
      fieldsDiv = el('div', 'hq-hw-fields hq-imperial-3col');
      fieldsDiv.appendChild(buildField('Height (ft)', 'hq-height-ft', 'number', saved.heightFt || '', '5'));
      fieldsDiv.appendChild(buildField('Height (in)', 'hq-height-in', 'number', saved.heightIn || '', '7'));
      fieldsDiv.appendChild(buildField('Weight (kg)', 'hq-weight-kg', 'number', saved.weightKg || '', '80'));
    }
    body.appendChild(fieldsDiv);

    var bmiPreview = el('div', 'hq-bmi-preview');
    bmiPreview.id = 'hq-bmi-preview';
    bmiPreview.style.display = 'none';
    body.appendChild(bmiPreview);

    fieldsDiv.querySelectorAll('.hq-field-input').forEach(function (inp) {
      inp.addEventListener('input', function () { updateBMIPreview(index); });
    });

    // Show BMI if values were already entered (e.g. navigated back)
    setTimeout(function () { updateBMIPreview(index); }, 0);
  }

  // ─── Goal Weight ────────────────────────────────────────────────────────────

  function renderGoalWeight(index, body) {
    var saved = state.answers[index] || {};
    var fieldsDiv = el('div', 'hq-hw-fields');
    fieldsDiv.style.gridTemplateColumns = '1fr';
    fieldsDiv.appendChild(buildField('Goal Weight (kg)', 'hq-goal-weight', 'number', saved.goalKg || '', '65'));
    body.appendChild(fieldsDiv);

    setTimeout(function () {
      var inp = document.getElementById('hq-goal-weight');
      if (inp) {
        inp.addEventListener('input', function () {
          state.answers[index] = { goalKg: parseFloat(inp.value) || 0 };
        });
      }
    }, 0);
  }

  function buildField(label, id, type, val, placeholder) {
    var g = el('div', 'hq-field-group');
    var lbl = el('label', 'hq-field-label', label);
    lbl.setAttribute('for', id);
    var inp = el('input', 'hq-field-input');
    inp.type = type;
    inp.id = id;
    if (val) inp.value = val;
    inp.placeholder = placeholder;
    if (type === 'number') { inp.min = '0'; inp.step = '0.1'; }
    g.appendChild(lbl);
    g.appendChild(inp);
    return g;
  }

  // ─── Footer ─────────────────────────────────────────────────────────────────

  function renderFooter(index, footer) {
    var prevBtn = el('button', 'hq-btn-prev');
    prevBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10 12L6 8L10 4" stroke="#0A0A0A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Previous`;
    if (index === 0) prevBtn.hidden = true;
    prevBtn.addEventListener('click', function () { goPrev(index); });

    var nextBtn = el('button', 'hq-btn-next');
    nextBtn.innerHTML = `Next <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 12L10 8L6 4" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>` ;
    nextBtn.addEventListener('click', function () { goNext(index); });

    footer.appendChild(prevBtn);
    footer.appendChild(nextBtn);
  }

  // ─── Validation ─────────────────────────────────────────────────────────────

  function validateCurrent(index) {
    var q = QUIZ_DATA.questions[index];
    if (q.type === 'height_weight') {
      saveHWValues(index);
      var ans = state.answers[index] || {};
      if (state.unit === 'metric') return (ans.heightCm > 0) && (ans.weightKg > 0);
      return (ans.heightFt > 0) && (ans.weightKg > 0);
    }
    if (q.type === 'goal_weight') {
      var inp = document.getElementById('hq-goal-weight');
      if (inp) state.answers[index] = { goalKg: parseFloat(inp.value) || 0 };
      var gAns = state.answers[index] || {};
      return gAns.goalKg > 0;
    }
    return true;
  }

  function showValidationError(index) {
    var errEl = document.getElementById('hq-val-err');
    var q = QUIZ_DATA.questions[index];
    var msg = q.type === 'height_weight'
      ? 'Please enter your height and weight to continue.'
      : 'Please enter your goal weight to continue.';
    if (errEl) {
      errEl.textContent = msg;
      errEl.style.display = 'block';
    }
    document.querySelectorAll('#hq-body .hq-field-input').forEach(function (inp) {
      if (!inp.value) {
        inp.classList.add('hq-input-error');
        setTimeout(function () { inp.classList.remove('hq-input-error'); }, 700);
      }
    });
  }

  // ─── Navigation ─────────────────────────────────────────────────────────────

  function goNext(index) {
    if (!validateCurrent(index)) { showValidationError(index); return; }
    if (index < QUIZ_DATA.questions.length - 1) {
      state.current = index + 1;
      renderQuestion(state.current);
    } else {
      showEligibility();
    }
  }

  function goPrev(index) {
    if (index > 0) {
      state.current = index - 1;
      renderQuestion(state.current);
    }
  }

  // ─── Eligibility ────────────────────────────────────────────────────────────

  function getBMICategory(bmi) {
    if (bmi < 18.5) return 'Underweight';
    if (bmi < 25)   return 'Healthy';
    if (bmi < 30)   return 'Overweight';
    if (bmi < 35)   return 'Obese Class I';
    if (bmi < 40)   return 'Obese Class II';
    return 'Obese Class III';
  }

  function updateBMIPreview(index) {
    saveHWValues(index);
    var preview = document.getElementById('hq-bmi-preview');
    if (!preview) return;
    var ans = state.answers[index] || {};
    var h = ans.heightM || 0;
    var w = ans.weightKg || 0;
    if (h > 0 && w > 0) {
      var bmi = Math.round((w / (h * h)) * 10) / 10;
      preview.innerHTML = 'Your BMI: <strong>' + bmi + '</strong> — ' + getBMICategory(bmi);
      preview.style.display = 'block';
    } else {
      preview.style.display = 'none';
    }
  }

  function getEligibilityData() {
    var hwAns = state.answers[2] || {};
    var weightKg = hwAns.weightKg || 0;
    var heightM  = hwAns.heightM  || 0;
    var bmi = heightM > 0 ? Math.round((weightKg / (heightM * heightM)) * 10) / 10 : 0;
    var bmiCat = getBMICategory(bmi);

    var condAns = state.answers[3];
    var hasCondition = Array.isArray(condAns) && condAns.some(function (c) {
      return QUALIFYING_CONDITIONS.indexOf(c) > -1;
    });

    var status, statusClass;
    if (bmi < 27) {
      status = 'Not Eligible'; statusClass = 'hq-not-eligible';
    } else if (hasCondition) {
      // BMI >= 27 with qualifying condition → Likely Eligible
      status = 'Likely Eligible'; statusClass = 'hq-likely-eligible';
    } else if (bmi < 30) {
      // BMI 27–29 with no condition → Not Eligible
      status = 'Not Eligible'; statusClass = 'hq-not-eligible';
    } else {
      // BMI >= 30 with no condition → Eligible
      status = 'Eligible'; statusClass = 'hq-eligible';
    }

    return { bmi: bmi, bmiCat: bmiCat, status: status, statusClass: statusClass, weightKg: weightKg, heightM: heightM };
  }

  function showEligibility() {
    var body   = document.getElementById('hq-body');
    var footer = document.getElementById('hq-footer');
    var total  = QUIZ_DATA.questions.length;

    var oldCtaWrap = document.querySelector('.hq-cta-sticky-wrap');
    if (oldCtaWrap) oldCtaWrap.parentNode.removeChild(oldCtaWrap);

    hideProgress();
    body.innerHTML = '';
    body.style.padding = '0';
    footer.innerHTML = '';
    footer.className = 'hq-footer hq-footer-elig';

    var elig = getEligibilityData();
    var isEligible = elig.statusClass !== 'hq-not-eligible';

    // Top bar
    var topBar = el('div', 'hq-elig-top-bar');
    topBar.innerHTML =
      '<div class="hq-elig-top-left">' +
        '<div class="hq-elig-heading">' +
          (isEligible
            ? "You\'re likely eligible for <span class='hq-elig-highlight'>GLP-1 therapy.</span>"
            : "Your BMI does not currently meet the standard threshold for GLP-1 therapy.") +
        '</div>' +
        '<div class="hq-elig-subtitle">Your BMI is ' + elig.bmi + ' (' + elig.bmiCat + '). GLP-1 therapy is typically indicated at BMI ≥ 30.</div>' +
      '</div>' +
      '<div class="hq-elig-tag">' + dotSVG() + ' Eligibility</div>';
    body.appendChild(topBar);

    // Card
    var card = el('div', 'hq-elig-card');
    var grid = el('div', 'hq-elig-grid');

    var leftCol = el('div', 'hq-elig-col');
    leftCol.innerHTML =
      '<div class="hq-elig-col-label">YOUR BMI</div>' +
      '<div class="hq-elig-bmi-val">' + elig.bmi + ' <span class="hq-elig-bmi-cat">' + elig.bmiCat + '</span></div>';

    var rightCol = el('div', 'hq-elig-col hq-elig-col-right');
    rightCol.innerHTML =
      '<div class="hq-elig-col-label">Eligibility</div>' +
      '<div class="hq-elig-status ' + elig.statusClass + '">' + elig.status + '</div>';

    grid.appendChild(leftCol);
    grid.appendChild(rightCol);
    card.appendChild(grid);

    var criteriaBox = el('div', 'hq-elig-criteria');
    criteriaBox.textContent = 'How we check: BMI ≥ 30, or BMI 27+ with a weight-related condition (hypertension, Type 2 diabetes, sleep apnea, PCOS, high cholesterol).';
    card.appendChild(criteriaBox);
    body.appendChild(card);

    // Footer
    var prevBtn = el('button', 'hq-btn-prev');
    prevBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10 12L6 8L10 4" stroke="#0A0A0A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Previous`;
    prevBtn.addEventListener('click', function () {
      body.style.padding = '';
      footer.className = 'hq-footer';
      state.current = total - 1;
      renderQuestion(state.current);
    });

    var disclaimer = el('div', 'hq-footer-disclaimer');
    disclaimer.textContent = 'Final eligibility is at the discretion of a licensed doctor based on your full medical evaluation.';

    footer.appendChild(prevBtn);
    footer.appendChild(disclaimer);

    if (isEligible) {
      var ctaBtn = el('button', 'hq-btn-next hq-cta');
      ctaBtn.innerHTML = `See how much you could lose <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 12L10 8L6 4" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
      ctaBtn.addEventListener('click', showProjection);
      footer.appendChild(ctaBtn);
    }

    body.appendChild(footer);   // re-attach after innerHTML clear
    scrollTop();
  }

  // ─── Projection ─────────────────────────────────────────────────────────────

  function showProjection() {
    var body   = document.getElementById('hq-body');
    var footer = document.getElementById('hq-footer');

    hideProgress();
    body.innerHTML = '';
    body.style.padding = '0';
    footer.innerHTML = '';
    footer.className = 'hq-footer';

    var elig = getEligibilityData();
    var weightKg  = elig.weightKg || 80;
    var projected = Math.round(weightKg * 0.85 * 10) / 10;
    var loss      = Math.round((weightKg - projected) * 10) / 10;

    var topBar = el('div', 'hq-results-bar');
    topBar.innerHTML =
      '<span>Here\'s how much you could lose with <strong class="hq-proj-brand">HealthifyRx</strong>.</span>' +
      '<span class="hq-projection-tag"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 80 80" fill="none"><path d="M40 4 C40 24 56 40 76 40 C56 40 40 56 40 76 C40 56 24 40 4 40 C24 40 40 24 40 4Z" fill="#005244"/></svg> Your Projection</span>';
    body.appendChild(topBar);

    var main  = el('div', 'hq-results-main');
    var left  = el('div', 'hq-results-left');
    left.innerHTML =
      '<div class="hq-results-current">You are currently <strong>' + weightKg + 'kg</strong></div>' +
      '<div class="hq-results-headline">With <span>HealthifyRx</span>, you could lose</div>' +
      '<div class="hq-results-stat"><div class="hq-stat-pill">' + loss + 'kg</div><span class="hq-stat-in">in</span><div class="hq-stat-pill">3 Months</div></div>' +
      '<div class="hq-results-citation">Based on peer-reviewed GLP-1 studies (Wilding et al., NEJM 2021; Jastreboff et al., NEJM 2022). Individual results may vary.</div>';

    var rightCol = el('div', 'hq-graph-col');

    var right = el('div', 'hq-graph-wrap');
    right.innerHTML = buildGraph(weightKg, projected);

    var legend = el('div', 'hq-graph-legend');
    legend.innerHTML =
      '<span class="hq-legend-item">' +
        '<svg width="20" height="10" viewBox="0 0 20 10"><line x1="0" y1="5" x2="20" y2="5" stroke="#2D5A3D" stroke-width="2.5" stroke-linecap="round"/></svg>' +
        ' Combined programme' +
      '</span>' +
      '<span class="hq-legend-item">' +
        '<svg width="20" height="10" viewBox="0 0 20 10"><line x1="0" y1="5" x2="20" y2="5" stroke="#6B7A6E" stroke-width="2" stroke-dasharray="4 3" stroke-linecap="round"/></svg>' +
        ' Medication alone' +
      '</span>';

    rightCol.appendChild(right);
    rightCol.appendChild(legend);

    main.appendChild(left);
    main.appendChild(rightCol);
    body.appendChild(main);

    var prevBtn = el('button', 'hq-btn-prev');
    prevBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10 12L6 8L10 4" stroke="#0A0A0A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Previous`;
    prevBtn.addEventListener('click', showEligibility);

    var ctaBtn = el('button', 'hq-btn-next hq-cta');
    ctaBtn.innerHTML = `Book My Free Consultation <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 12L10 8L6 4" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
    ctaBtn.addEventListener('click', function () { window.location.href = '/pages/consultation'; });

    footer.appendChild(prevBtn);

    var oldCtaWrap = document.querySelector('.hq-cta-sticky-wrap');
    if (oldCtaWrap) oldCtaWrap.parentNode.removeChild(oldCtaWrap);

    if (window.innerWidth <= 749) {
      body.appendChild(footer);
      var ctaWrap = el('div', 'hq-cta-sticky-wrap');
      ctaWrap.appendChild(ctaBtn);
      document.getElementById('hq-card').appendChild(ctaWrap);
    } else {
      footer.appendChild(ctaBtn);
      body.appendChild(footer);
    }
    scrollTop();
  }

  // ─── SVG Graph ──────────────────────────────────────────────────────────────

  function buildGraph(currentKg, projectedKg) {
    var startLabel = currentKg + 'kg';
    var endLabel   = projectedKg + 'kg';
    return '<svg viewBox="0 0 340 220" width="100%" style="display:block;">' +
      '<defs>' +
        '<linearGradient id="hrx-juniper-area" x1="0" y1="0" x2="0" y2="1">' +
          '<stop offset="0%" stop-color="#2D5A3D" stop-opacity="0.18"></stop>' +
          '<stop offset="100%" stop-color="#2D5A3D" stop-opacity="0"></stop>' +
        '</linearGradient>' +
      '</defs>' +
      '<line x1="18" y1="76" x2="322" y2="76" stroke="#D8D5CF" stroke-dasharray="3 4"></line>' +
      '<line x1="18" y1="112" x2="322" y2="112" stroke="#D8D5CF" stroke-dasharray="3 4"></line>' +
      '<line x1="18" y1="148" x2="322" y2="148" stroke="#D8D5CF" stroke-dasharray="3 4"></line>' +
      '<line x1="18" y1="184" x2="322" y2="184" stroke="#D8D5CF" stroke-dasharray="3 4"></line>' +
      '<line x1="18" y1="184" x2="322" y2="184" stroke="#A8A59E"></line>' +
      '<path d="M 18.0 40.0 L 30.7 44.3 L 43.3 48.6 L 56.0 52.8 L 68.7 56.9 L 81.3 61.0 L 94.0 65.0 L 106.7 69.0 L 119.3 72.9 L 132.0 76.7 L 144.7 80.4 L 157.3 84.1 L 170.0 87.6 L 182.7 91.1 L 195.3 94.5 L 208.0 97.8 L 220.7 101.0 L 233.3 104.1 L 246.0 107.0 L 258.7 109.8 L 271.3 112.4 L 284.0 114.9 L 296.7 117.1 L 309.3 118.9 L 322.0 120.2" fill="none" stroke="#6B7A6E" stroke-width="2" stroke-dasharray="5 5" stroke-linecap="round"></path>' +
      '<path d="M 18.0 40.0 L 30.7 47.9 L 43.3 55.6 L 56.0 63.1 L 68.7 70.4 L 81.3 77.5 L 94.0 84.4 L 106.7 91.1 L 119.3 97.6 L 132.0 103.9 L 144.7 109.9 L 157.3 115.7 L 170.0 121.3 L 182.7 126.6 L 195.3 131.7 L 208.0 136.4 L 220.7 140.9 L 233.3 145.1 L 246.0 149.0 L 258.7 152.6 L 271.3 155.7 L 284.0 158.5 L 296.7 160.8 L 309.3 162.5 L 322.0 163.4 L 322 184 L 18 184 Z" fill="url(#hrx-juniper-area)"></path>' +
      '<path d="M 18.0 40.0 L 30.7 47.9 L 43.3 55.6 L 56.0 63.1 L 68.7 70.4 L 81.3 77.5 L 94.0 84.4 L 106.7 91.1 L 119.3 97.6 L 132.0 103.9 L 144.7 109.9 L 157.3 115.7 L 170.0 121.3 L 182.7 126.6 L 195.3 131.7 L 208.0 136.4 L 220.7 140.9 L 233.3 145.1 L 246.0 149.0 L 258.7 152.6 L 271.3 155.7 L 284.0 158.5 L 296.7 160.8 L 309.3 162.5 L 322.0 163.4" fill="none" stroke="#2D5A3D" stroke-width="3" stroke-linecap="round"></path>' +
      '<circle cx="18" cy="40" r="5" fill="#fff" stroke="#2D5A3D" stroke-width="2.5"></circle>' +
      '<g><rect x="8" y="8" width="52" height="22" rx="5" fill="#2D5A3D"></rect>' +
      '<text x="34" y="23" fill="#fff" font-size="11" font-weight="700" text-anchor="middle" font-family="sans-serif">' + startLabel + '</text>' +
      '<line x1="18" y1="30" x2="18" y2="35" stroke="#2D5A3D" stroke-width="2"></line></g>' +
      '<circle cx="322" cy="163.4" r="5" fill="#fff" stroke="#2D5A3D" stroke-width="2.5"></circle>' +
      '<g><rect x="278" y="173.4" width="52" height="22" rx="5" fill="#15201B"></rect>' +
      '<text x="304" y="188.4" fill="#fff" font-size="11" font-weight="700" text-anchor="middle" font-family="sans-serif">' + endLabel + '</text>' +
      '<line x1="322" y1="168.4" x2="322" y2="173.4" stroke="#15201B" stroke-width="2"></line></g>' +
      '<text x="18" y="212" fill="#6B7A6E" font-size="11" font-family="sans-serif">Now</text>' +
      '<text x="322" y="212" fill="#6B7A6E" font-size="11" text-anchor="end" font-family="sans-serif">3 months</text>' +
      '</svg>';
  }

  // ─── Helpers ────────────────────────────────────────────────────────────────

  function scrollTop() {
    var card = document.getElementById('hq-card');
    if (card) card.scrollTop = 0;
  }

  // ─── Open / Close ────────────────────────────────────────────────────────────

  function openQuiz() {
    var overlay = document.getElementById('hq-overlay') || buildOverlay();
    state.current = 0;
    state.answers = {};
    state.unit = 'metric';
    renderQuestion(0);
    requestAnimationFrame(function () {
      overlay.classList.add('hq-active');
      document.body.style.overflow = 'hidden';
    });
  }

  function closeQuiz() {
    var overlay = document.getElementById('hq-overlay');
    if (overlay) {
      overlay.classList.remove('hq-active');
      document.body.style.overflow = '';
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeQuiz();
  });

  function bindTriggers() {
    document.querySelectorAll('[data-healthify-quiz], .iwc-info-button').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openQuiz();
      });
    });
  }

  window.HealthifyQuiz = { open: openQuiz, close: closeQuiz };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTriggers);
  } else {
    bindTriggers();
  }
})();
